import React from 'react';
import { PHONE_REGISTRATION_COLUMNS } from '../constants';

const PhoneRegistrationDefaultColumnCells = () =>
  PHONE_REGISTRATION_COLUMNS.map((fieldName) => {
    return <td key={fieldName} />;
  });

export default PhoneRegistrationDefaultColumnCells;
